<template>
  <component :is="formItemType" :item="item" :formItems="formItems" :readonly="readonly"/>
</template>
<script>
import FormItemAutoComplete from './auto-complete'
import FormItemCascader from './cascader'
import FormItemCheckbox from './checkbox'
import FormItemDatePicker from './date-picker'
import FormItemDatetimeRange from './datetimerange'
import FormItemInput from './input'
import FormItemRadio from './radio'
import FormItemSelect from './select'
import FormItemSwitch from './switch'
import FormItemTag from './tag'
import FormItemText from './text'
import FormItemTree from './tree'
import FormItemInputNumber from './input-number'
import FormItemRender from './render'
import props from './props'
export default {
  name: 'my-form-item',
  components: {
    FormItemAutoComplete,
    FormItemCascader,
    FormItemCheckbox,
    FormItemDatePicker,
    FormItemDatetimeRange,
    FormItemInput,
    FormItemRadio,
    FormItemSelect,
    FormItemSwitch,
    FormItemTag,
    FormItemText,
    FormItemTree,
    FormItemInputNumber,
    FormItemRender,
  },
  mixins: [props],
  data () {
    return {}
  },
  computed: {
    formItemType () {
      let { type, render } = this.item
      if (['year', 'month', 'date', 'datetime', 'daterange'].includes(type)) {
        type = 'date-picker'
      }
      if (render) {
        type = 'render'
      } else if (!type) {
        console.warn('这个数据没传type或render，', this.item, '，暂时给了input作为响应，记得修改')
        type = 'input'
      }
      return `form-item-${type}`
    }
  }
}
</script>
